import axios from 'axios'
const guideTable = async (requestAddress, condition) => {
  const manager = JSON.parse(window.localStorage.getItem('manager'));
  const config = {
    headers: {
      "Authorization": 'Bearer ' + manager.userInfo.access_token
    },
    responseType: 'blob'
  }
  const result = await axios.post((process.env.NODE_ENV === 'development' ? '/api' : process.env.VUE_APP_BASE_API) + requestAddress, {
    condition
  }, config);
  const blob = new Blob([result.data], {
    type: 'application/vnd.openxmlformats'
  });
  const downloadElement = document.createElement('a');
  const href = window.URL.createObjectURL(blob);
  downloadElement.href = href;
  const originalFileName = result.headers['content-disposition'].replace(`attachment;filename*=UTF-8' '`, '');
  const fileExtension = originalFileName.match(/\.[\w]+/g)[0];
  const fileName = decodeURI(decodeURI(originalFileName.replace(fileExtension, '')));
  const fileFullName = fileName + fileExtension;
  downloadElement.download = fileFullName;
  downloadElement.click();
  document.removeChild(downloadElement);
}
export default {
  guideTable
};
